// extracted by mini-css-extract-plugin
export default {"label":"label--99e578","content-block":"content-block--e6057e","contentBlock":"content-block--e6057e"};